import onlineOrder from './imgs/online-order.png'
import simpleReport from './imgs/simple-report.png'
import simplicity from './imgs/simplicity.png'
import tableService from './imgs/table-service.png'
import RestaurantIcon from '@mui/icons-material/Restaurant'
import TagFacesIcon from '@mui/icons-material/TagFaces'
import SummarizeIcon from '@mui/icons-material/Summarize'
import TableBarIcon from '@mui/icons-material/TableBar'
import { useEffect, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'

const AdsLists = [
    {
        title: 'Online Order',
        pic: onlineOrder,
        icon: (
            <RestaurantIcon
                color="warning"
                sx={{
                    mr: 1,
                }}
            />
        ),
    },
    {
        title: 'Simplicity',
        pic: simplicity,
        icon: (
            <TagFacesIcon
                color="warning"
                sx={{
                    mr: 1,
                }}
            />
        ),
    },
    {
        title: 'Simple Report',
        pic: simpleReport,
        icon: (
            <SummarizeIcon
                color="warning"
                sx={{
                    mr: 1,
                }}
            />
        ),
    },
    {
        title: 'Table Service',
        pic: tableService,
        icon: (
            <TableBarIcon
                color="warning"
                sx={{
                    mr: 1,
                }}
            />
        ),
    },
]

function AdsList() {
    const [curIndex, setCurIndex] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurIndex((prev) => (prev === AdsLists.length - 1 ? 0 : prev + 1))
            console.log('This will run every second!')
        }, 2000)
        return () => clearInterval(interval)
    }, [])

    const curAds = AdsLists[curIndex]
    return (
        <Grid
            container
            sx={{
                backgroundColor: (t) => t.palette.primary.dark,
                borderRadius: 4,
            }}
            direction={curIndex % 2 === 0 ? 'row' : 'row-reverse'}
        >
            <Grid
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                size={{
                    sm: 5,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: 'white',
                        borderRadius: 12,

                        m: 2,
                        py: 1,
                        px: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: 3,
                    }}
                >
                    {curAds.icon}
                    <Typography
                        color={'primary'}
                        fontWeight={'bold'}
                        variant={'h6'}
                    >
                        {curAds.title}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                p={0}
                size={{
                    sm: 7,
                }}
            >
                <Box
                    src={curAds.pic}
                    component={'img'}
                    sx={{
                        width: '100%',
                        height: 400,
                        objectFit: 'cover',
                        borderRadius: 4,
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default AdsList
